import { useMemo, useRef } from 'react';
import { useWindowVirtualizer } from '@tanstack/react-virtual';

import type { BaseRowData } from '@adv-frontend/data-provider';

import { useKeepMountedRowRange } from '../../../hooks/useKeepMountedRowRange';
import { useWindowScrollMargin } from '../../../hooks/useWindowScrollMargin';

import { useVirtualBodyContent } from './VirtualBodyContent';
import type { VirtualBodyProps } from './VirtualBody.types';
import { useRowVirtualizationOptions } from './useRowVirtualizationOptions';

export function WindowKeepMountedVirtualRows<RowData extends BaseRowData>(props: VirtualBodyProps<RowData>) {
    const bodyRef = useRef<HTMLDivElement>(null);
    const rowIds = useMemo(() => props.rows.map(row => row.id), [props.rows]);
    const { getRetainedIndexes, commitRows } = useKeepMountedRowRange(rowIds);
    const options = useRowVirtualizationOptions(props, { getRetainedIndexes });
    const { scrollMargin, isReady } = useWindowScrollMargin(bodyRef);
    const rowVirtualizer = useWindowVirtualizer<HTMLDivElement>({
        ...options,
        scrollMargin,
    });

    return useVirtualBodyContent({
        ...props,
        mode: 'window-keep-mounted',
        rowVirtualizer,
        commitRows,
        bodyRef,
        scrollMargin,
        isReady,
    });
}
